import {getAgenteAccessToken} from "@/services/tokens.service";
import {mainAxios} from "@/mainAxios";

export const createAvailability = async (payload) => {
    const config = {
        headers: {
            Authorization: "Bearer " + getAgenteAccessToken(),
        },
    };

    return await mainAxios.post(
        "/v1/agente/disponibilidad",
        payload,
        config
    );
};

export const getAvailabilities = async () => {
    const config = {
        headers: {
            Authorization: "Bearer " + getAgenteAccessToken(),
        }
    };

    const serverResponse = await mainAxios.get(
        "/v1/agente/disponibilidad",
        config
    )
    return serverResponse.data;
}

export const setAgentNotReady = (agentId, prevAvailability) => {
    const payload = {
        agenteId: agentId,
        status: "not_ready",
        lastStatusChange: prevAvailability?.status ?? "created",
    };
    if (prevAvailability?.id) payload.id = prevAvailability.id;

    return fetch(`${process.env.VUE_APP_API_URL}/v1/agente/disponibilidad`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getAgenteAccessToken()}`,
        },
        body: JSON.stringify(payload),
        keepalive: true,
    });
};
